"use strict";

exports.includes = includes;

function includes(array, detectValue) {
  for (var i = 0; i < array.length; i++) {
    var value = array[i];
    if (value === detectValue) {
      return true;
    }
  }
  return false;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/mobiledoc-dom-renderer/dist/commonjs/mobiledoc-dom-renderer/utils/array-utils.js
// module id = 1501
// module chunks = 0